/* eslint-disable no-confusing-arrow */
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 0 !important;

  display: flex !important;
  flex-direction: row;
  align-items: center;
`;

export const ProgressBarContainer = styled.div`
  margin: 0 !important;
  position: relative;

  width: 60%;
  height: 6px;

  background: ${props => props.color};
  border-radius: 10px;
`;

export const ProgressBar = styled.div`
  margin: 0 !important;
  position: absolute;

  width: ${props => (props.progress < 100 ? props.progress : 100)}%;
  height: 6px;

  background: ${props => props.color};
  border-radius: 10px;
`;

export const Label = styled.p`
  margin: 0 !important;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;

  padding: 5px;
  margin-left: 8px !important;
`;
